import React from 'react';
import { useLocation } from 'react-router-dom';

function StatFeature({ isMobile, t }) {
  const location = useLocation();

  // Données exemple basées sur votre image
  const data = [
    { name: "Emily", amount: 258.39, positive: true },
    { name: "Tom", amount: -299.61, positive: false },
    { name: "Me", amount: 122.94, positive: true },
    { name: "Sophia", amount: 134.39, positive: true },
    { name: "James", amount: -216.11, positive: false }
  ];

  const debts = [
    { from: "James", amount: 122.94, to: t.me, highlighted: true },
    { from: "Tom", amount: 258.39, to: "Emily", highlighted: false },
    { from: "Tom", amount: 41.22, to: "Sophia", highlighted: false },
    { from: "James", amount: 93.17, to: "Sophia", highlighted: false },
  ];
  // Calcul du max pour la proportion des barres
  const maxAmount = Math.max(...data.map(d => Math.abs(d.amount)));

  return (
    <section
      style={{
        marginTop: 200, // Réduit un peu pour la démo, ajustez selon besoin
        marginBottom: 40,
        width: '100%',
        display: 'flex',
        justifyContent: 'center'
      }}
    >
      <div
        style={{
          maxWidth: '1200px',
          width: '100%',
          padding: isMobile ? '0 20px' : '0 40px',
          color: '#f9fafb'
        }}
      >
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 16,
            justifyContent: 'center'
          }}
        >
          <div
            style={{
              justifyContent: 'start',
              borderRadius: 18,
              padding: 18,
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              gap: 50,
              alignItems: 'center',
              backdropFilter: 'blur(10px)',
            }}
          >
            {/* --- GRAPHIQUE INTEGRÉ ICI --- */}
            <div style={{ width: isMobile ? '100%' : '350px' }}>
              {data.map((item, index) => {
                const percentage = (Math.abs(item.amount) / maxAmount) * 100;
                return (
                  <div 
                    key={index} 
                    style={{ 
                      display: 'flex', 
                      flexDirection: item.positive ? 'row' : 'row-reverse',
                      alignItems: 'center',
                      marginBottom: 20,
                      borderBottom: '1px solid rgba(255,255,255,0.1)',
                      paddingBottom: 12
                    }}
                  >
                    {/* Texte (Nom + Montant) */}
                    <div style={{ 
                      flex: 1, 
                      textAlign: item.positive ? 'left' : 'right',
                      display: 'flex',
                      flexDirection: 'column',
                      marginLeft: item.positive ? 30 : 0,
                      marginRight: item.positive ? 0 : 30,
                    }}>
                      <span style={{ fontSize: '1rem', fontWeight: '500' }}>{item.name}</span>
                      <span style={{ fontSize: '0.9rem', opacity: 0.8 }}>
                        {item.positive ? '+ ' : '- '}
                        {Math.abs(item.amount).toFixed(2)} {t.devise}
                      </span>
                    </div>

                    {/* Barre */}
                    <div style={{ 
                      flex: 1.2, 
                      display: 'flex', 
                      justifyContent: item.positive ? 'flex-start' : 'flex-end' 
                    }}>
                      <div style={{
                        width: `${percentage}%`,
                        height: 32,
                        background: item.positive 
                          ? 'linear-gradient(90deg, #6366f1, #818cf8)' 
                          : 'linear-gradient(90deg, #db2777, #7c3aed)',
                        borderTopRightRadius: item.positive ? 12 : 0,
                        borderBottomRightRadius: item.positive ? 12 : 0,
                        borderTopLeftRadius: item.positive ? 0 : 12,
                        borderBottomLeftRadius: item.positive ? 0 : 12,
                      }} />
                    </div>
                  </div>
                );
              })}
            </div>

            {/* --- TEXTE DESCRIPTIF --- */}
            <div style={{ flex: 1, maxWidth: 400 }}>
              <h3
                style={{
                  margin: '0 0 8px 0',
                  fontSize: '2rem',
                  fontFamily: 'Poppins-Medium'
                }}
              >
                {t.StatTitle}
              </h3>
              <p
                style={{
                  margin: 0,
                  fontSize: '1.1rem',
                  opacity: 0.9,
                  lineHeight: 1.6
                }}
              >
                {t.StatText}
              </p>
            </div>
            {/* 3. BLOC DETTES (DROITE) */}
          <div style={{ width: isMobile ? '100%' : '350px', display: 'flex', flexDirection: 'column', gap: 12 }}>
            {debts.map((debt, index) => (
              <div key={index} style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '14px 20px',
                borderRadius: 16,
                backgroundColor: debt.highlighted ? 'rgba(99, 102, 241, 0.15)' : 'transparent',
                border: debt.highlighted ? '1px solid rgba(99, 102, 241, 0.3)' : '1px solid transparent',
              }}>
                <span style={{ color: '#a5b4fc', fontSize: '1.05rem', fontWeight: '500' }}>{debt.from}</span>
                <span style={{ fontSize: '0.9rem', opacity: 0.6 }}>{(location.pathname === '/fr' && index === 0) ? 'me doit' : t.owes}</span>
                <span style={{ fontWeight: '600', fontSize: '1.05rem' }}>{debt.amount.toFixed(2)} {t.devise}</span>
                <span style={{ fontSize: '0.9rem', opacity: 0.6 }}>{(location.pathname === '/fr' && index === 0) ? '' : t.to}</span>
                <span style={{ color: '#7dd3fc', fontWeight: '500', fontSize: '1.05rem' }}>{(location.pathname === '/fr' && index == 0) ? '' : debt.to}</span>
              </div>
            ))}
          </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default StatFeature;